<template>
  <div>
    <el-drawer
      v-if="visible"
      :size="1100"
      :title="$l('dialog_title_skuReply')"
      :visible="visible"
      direction="rtl"
      @close="close"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          @close="close"
          :amzReplenishmentDetailCode="amzReplenishmentDetailCode"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="close">
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    amzReplenishmentDetailCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
